/* ============================================================
   DATA MEDICAL CHECK UP

   Letakkan di: app/layanan/mcu/mcu.js

   ============================================================
   SUMBER DATA - ENAM LEMBAR POSTER

     1.jpeg  MCU General - Paket A, B, C, D + tambahan A, B, C
     2.jpeg  MCU General - tambahan D, Paket E, Paket F, gratis
     3.jpeg  MCU Sesuai Usia - sampul
     4.jpeg  MCU Sesuai Usia - 18-25 dan >25-40 tahun
     5.jpeg  MCU Sesuai Usia - >40-50 tahun
     6.jpeg  MCU Sesuai Usia - >50 tahun + daftar gratis
     7.jpeg  MCU Anak - bayi, balita, sekolah dini, remaja
     8.jpeg  MCU Anak - lembar kedua ⚠️ BELUM SAYA LIHAT ISINYA
     9.jpeg  Paket Screening Ginjal Anak
    10.jpeg  MCU Baby Sitter / Driver / Care Giver - Paket A, B, C
    11.jpeg  MCU Baby Sitter / Driver / Care Giver - lembar kedua
             ⚠️ BELUM SAYA LIHAT ISINYA
    12.jpeg  MCU Ekonomis - paket tunggal 312 ribu
    13.jpeg  MCU Ekonomis - lembar kedua ⚠️ BELUM SAYA LIHAT ISINYA
    14.jpg   MCU Premarital - Standard, Silver, Gold
    15.jpeg  Tes Urin Narkoba 6 Parameter - penawaran terbatas 2022
    16.jpeg  Tes Urin Narkoba + konsultasi spesialis - penawaran khusus
             ⚠️ PERHATIKAN: berkas ini .jpg, tiga belas lainnya .jpeg.
             Kalau halaman gagal dimuat, periksa akhiran berkasnya dan
             samakan dengan baris impor di bawah.

   Tidak ada nama pemeriksaan atau angka yang ditambahkan dari luar
   keenam lembar itu.

   ⚠️ POSTER GENERAL BERKODE "01/MEDIA/MKT-RSJMC/XI/2022" - November
   2022. Konfirmasi tarif ke keuangan sebelum tayang, lalu isi
   TARIF_DIPERBARUI.

   ⚠️⚠️ POSTER SESUAI USIA TIDAK MENCANTUMKAN HARGA SAMA SEKALI.
   Keempat paketnya `harga: null`, jadi kartunya menampilkan "Hubungi
   kami". Ini bukan kelalaian penyalinan - angkanya memang tidak ada
   di lembar mana pun.

   ============================================================
   DUA KATEGORI, BUKAN SATU DAFTAR PANJANG

   MCU General dipilih berdasarkan anggaran dan kelengkapan (A-F).
   MCU Sesuai Usia dipilih berdasarkan umur. Tidak ada yang perlu
   membandingkan "Paket C" dengan "Usia 18-25" - keduanya menjawab
   pertanyaan yang berbeda, jadi keduanya berdiri sendiri-sendiri di
   halaman, dengan poster dan daftar gratisnya masing-masing.

   Hanya kotak reservasi yang menyatukan keduanya, karena di sana
   pengunjung memang sudah memutuskan.

   ============================================================
   BENTUK DATA

   KATEGORI[]
     kunci     dipakai untuk id jangkar dan kunci React
     nama      { id, en }
     ringkas   { id, en } - satu kalimat di bawah judul kategori
     paket[]   daftar paketnya
     varian[]  baris tabel tambahan. KOSONG = tabel tidak dirender
     poster[]  lembar posternya
     gratis[]  yang termasuk tanpa biaya tambahan
     catatan[] catatan operasional

   paket[]
     kode      lencana kecil - "A" atau "18-25"
     nama      { id, en }
     julukan   { id, en } - boleh null
     catatan   { id, en } - boleh dihilangkan
     harga     angka rupiah polos, atau null kalau tidak tercantum
     isi       daftar pemeriksaan { id, en }, URUT sesuai poster
     varian    harga TOTAL paket + satu tambahan (bukan selisih).
               Kategori tanpa tambahan cukup { dasar: harga }.
   ============================================================ */

/* Impor statis, BUKAN string path. Berkas di dalam app/ tidak
   disajikan sebagai URL - "/layanan/mcu/images/1.jpeg" akan 404. */
import poster1 from "./images/1.jpeg";
import poster2 from "./images/2.jpeg";
import poster3 from "./images/3.jpeg";
import poster4 from "./images/4.jpeg";
import poster5 from "./images/5.jpeg";
import poster6 from "./images/6.jpeg";
import poster7 from "./images/7.jpeg";
import poster8 from "./images/8.jpeg";
import poster9 from "./images/9.jpeg";
import poster10 from "./images/10.jpeg";
import poster11 from "./images/11.jpeg";
import poster12 from "./images/12.jpeg";
import poster13 from "./images/13.jpeg";
import poster14 from "./images/14.jpeg";
import poster15 from "./images/15.jpeg";

export const TARIF_DIPERBARUI = null;

/* ============================================================
   JADWAL PELAYANAN MCU

   ⚠️⚠️ ANGKA DI BAWAH BELUM DIKONFIRMASI RS JMC. Tidak ada satu pun
   dari enam belas lembar poster yang menyebut jam pelayanan MCU.

   Yang dipakai sekarang adalah pola yang lazim di rumah sakit
   Indonesia untuk MCU berbasis puasa:

     - dilayani pagi, karena sepuluh dari paket ini memuat glukosa
       puasa dan darah harus diambil sebelum pasien makan
     - pendaftaran ditutup sekitar pukul 11.00, supaya masih sempat
       pengambilan darah kedua dua jam setelah makan (post prandial)
     - Sabtu lebih pendek
     - Minggu tutup

   POLA ITU MASUK AKAL, TAPI TETAP TEBAKAN. Pasien yang datang pukul
   07.30 dan menemukan laboratorium baru buka pukul 08.00 tidak akan
   menganggapnya tebakan yang masuk akal.

   BEGITU BAGIAN LABORATORIUM MEMBERI JAM SEBENARNYA:
     1. perbaiki `hari` di bawah
     2. ubah `dikonfirmasi` jadi true

   Selama `dikonfirmasi` masih false, spanduk merah mode pengembangan
   terus mengingatkan.

   Bentuk `hari`: kunci 0 = Minggu, 1 = Senin, ... 6 = Sabtu.
   Hari yang TIDAK ada kuncinya dianggap tutup, dan tanggalnya tidak
   bisa dipakai di formulir reservasi.
   ============================================================ */
export const JADWAL = {
  dikonfirmasi: false,
  jarakMenit: 30,
  hari: {
    1: { mulai: "07:30", akhir: "11:00" },
    2: { mulai: "07:30", akhir: "11:00" },
    3: { mulai: "07:30", akhir: "11:00" },
    4: { mulai: "07:30", akhir: "11:00" },
    5: { mulai: "07:30", akhir: "11:00" },
    6: { mulai: "07:30", akhir: "10:00" },
  },
};

export const KONTAK_MCU = {
  telepon: { tampil: "(021) 798 0888", tel: "+62217980888" },
  cs: { tampil: "0811-901-874", wa: "62811901874" },
};

/* ===============================================                                  =============
   NAMA PEMERIKSAAN

   Ditulis sekali, dipakai berulang. Perhatikan: poster General dan
   poster Sesuai Usia MENULIS BEBERAPA NAMA DENGAN CARA BERBEDA -
   "Hematologi lengkap" vs "Hematologi lengkap (DPL + LED)",
   "Kolesterol HDL" terpisah vs "Kolesterol HDL + LDL" digabung.

   Keduanya dipertahankan apa adanya, tidak diseragamkan. Kalau nanti
   RS mengonfirmasi bahwa isinya memang sama, barulah boleh disatukan.
   ============================================================ */
const P = {
  hematologi: { id: "Hematologi lengkap", en: "Complete blood count" },
  hematologiDpl: {
    id: "Hematologi lengkap (DPL + LED)",
    en: "Complete blood count (CBC + ESR)",
  },
  urine: { id: "Urine lengkap", en: "Complete urinalysis" },
  ureum: { id: "Ureum darah", en: "Blood urea" },
  kreatinin: { id: "Kreatinin darah", en: "Blood creatinine" },
  asamUrat: { id: "Asam urat darah", en: "Blood uric acid" },
  proteinTotal: { id: "Protein total", en: "Total protein" },
  albumin: { id: "Albumin", en: "Albumin" },
  globulin: { id: "Globulin", en: "Globulin" },
  bilirubinTotal: { id: "Bilirubin total", en: "Total bilirubin" },
  bilirubinIndirek: { id: "Bilirubin indirek", en: "Indirect bilirubin" },
  bilirubinDirek: { id: "Bilirubin direk", en: "Direct bilirubin" },
  sgot: { id: "SGOT", en: "SGOT (AST)" },
  sgpt: { id: "SGPT", en: "SGPT (ALT)" },
  trigliserida: { id: "Trigliserida", en: "Triglycerides" },
  glukosa: {
    id: "Glukosa puasa & 2 jam post prandial",
    en: "Fasting & 2-hour postprandial glucose",
  },
  kolesterolTotal: { id: "Kolesterol total", en: "Total cholesterol" },
  kolesterolHdl: { id: "Kolesterol HDL", en: "HDL cholesterol" },
  kolesterolLdl: { id: "Kolesterol LDL", en: "LDL cholesterol" },
  kolesterolHdlLdl: {
    id: "Kolesterol HDL + LDL",
    en: "HDL + LDL cholesterol",
  },
  hba1c: { id: "HbA1c", en: "HbA1c" },
  hbsag: { id: "HBsAg kuantitatif", en: "Quantitative HBsAg" },
  hbsagPolos: { id: "HBsAg", en: "HBsAg" },
  antiHbs: {
    id: "Anti HBs (dengan titer kuantitatif)",
    en: "Anti-HBs (with quantitative titre)",
  },
  antiHbsPolos: { id: "Anti HBs", en: "Anti-HBs" },
  antiHcv: { id: "Anti HCV", en: "Anti-HCV" },
  antiHcvTiter: {
    id: "Anti HCV (dengan titer kuantitatif)",
    en: "Anti-HCV (with quantitative titre)",
  },
  vdrl: { id: "VDRL", en: "VDRL" },
  gammaGt: { id: "Gamma GT", en: "Gamma GT" },
  cholineEsterase: { id: "Choline esterase", en: "Cholinesterase" },
  fosfataseAlkali: { id: "Fosfatase alkali", en: "Alkaline phosphatase" },
  ldh: { id: "LDH", en: "LDH" },
  lipoproteinA: { id: "Lipoprotein (A)", en: "Lipoprotein (a)" },
  elektrolit: { id: "Elektrolit (Na, K, Cl)", en: "Electrolytes (Na, K, Cl)" },
  fotoThorax: { id: "Foto thorax", en: "Chest X-ray" },
  usgAbdomen: { id: "USG abdomen", en: "Abdominal ultrasound" },
  ekg: { id: "EKG", en: "ECG" },
  konsulPenyakitDalam: {
    id: "Konsultasi dokter spesialis penyakit dalam",
    en: "Consultation with an internal medicine specialist",
  },

  /* ---- khusus MCU Anak ---- */
  tshNeonatus: { id: "TSHs neonatus", en: "Neonatal TSH" },
  golonganDarahRhesus: { id: "Golongan darah / rhesus", en: "Blood type / rhesus" },
  darahLengkap: { id: "Darah lengkap", en: "Complete blood count" },
  totalProtein: { id: "Total protein", en: "Total protein" },
  profilLipid: { id: "Profil lipid", en: "Lipid profile" },
  /* Poster menulis "Feritin Merujuk RS JMC". Maksudnya kemungkinan
     besar pemeriksaan yang dirujuk ke luar, tapi kalimatnya tidak
     jelas - dipertahankan mendekati aslinya sampai RS menjelaskan. */
  feritin: { id: "Feritin (merujuk RS JMC)", en: "Ferritin (referred by RS JMC)" },
  /* Poster menulis "Feases Lengkap" - salah ketik untuk faeces. */
  faecesLengkap: { id: "Faeces lengkap", en: "Full stool test" },
  fungsiGinjal: {
    id: "Fungsi ginjal (ureum, kreatinin, asam urat)",
    en: "Kidney function (urea, creatinine, uric acid)",
  },
  fungsiHati: { id: "Fungsi hati (SGOT, SGPT)", en: "Liver function (AST, ALT)" },
  konsulSpesialisAnak: {
    id: "Pemeriksaan dokter spesialis anak",
    en: "Examination by a paediatrician",
  },
  labDarahLengkap: {
    id: "Pemeriksaan laboratorium darah lengkap",
    en: "Complete blood count",
  },
  labFungsiGinjal: {
    id: "Pemeriksaan laboratorium fungsi ginjal (ureum + kreatinin)",
    en: "Kidney function tests (urea + creatinine)",
  },

  /* ---- khusus MCU Baby Sitter / Driver / Care Giver ---- */
  hematologiLed: {
    id: "Hematologi lengkap + LED",
    en: "Complete blood count + ESR",
  },
  gulaDarahSewaktu: { id: "Gula darah sewaktu", en: "Random blood glucose" },
  konsulUmum: {
    id: "Konsultasi dokter umum",
    en: "General practitioner consultation",
  },

  /* ---- khusus MCU Ekonomis ---- */
  pemeriksaanDokter: { id: "Pemeriksaan dokter", en: "Doctor's examination" },
  labDarah: { id: "Laboratorium darah", en: "Blood laboratory tests" },
  rontgen: { id: "Rontgen", en: "X-ray" },
};

/* ============================================================
   BARIS TABEL TAMBAHAN - hanya untuk MCU General
   ============================================================ */
const VARIAN_GENERAL = [
  { kunci: "dasar", nama: { id: "Paket dasar", en: "Base package" } },
  { kunci: "golDarah", nama: { id: "+ Golongan darah", en: "+ Blood type" } },
  { kunci: "faeces", nama: { id: "+ Faeces lengkap", en: "+ Full stool test" } },
  { kunci: "thorax", nama: { id: "+ Foto thorax", en: "+ Chest X-ray" } },
  { kunci: "usg", nama: { id: "+ USG abdomen", en: "+ Abdominal ultrasound" } },
  { kunci: "papSmear", nama: { id: "+ Pap smear (wanita)", en: "+ Pap smear (women)" } },
  { kunci: "psa", nama: { id: "+ PSA (pria di atas 50 tahun)", en: "+ PSA (men over 50)" } },
  { kunci: "gigi", nama: { id: "+ Periksa gigi", en: "+ Dental check" } },
  { kunci: "mata", nama: { id: "+ Periksa mata", en: "+ Eye check" } },
  {
    kunci: "semua",
    /* Poster menulis "Paket A Total +++" - tiga tanda plus untuk tiga
       tambahan di atasnya. Ditulis lengkap di sini supaya tidak ada
       yang bertanya "total apa". */
    nama: {
      id: "Paket A + golongan darah + faeces + foto thorax",
      en: "Package A + blood type + stool test + chest X-ray",
    },
  },
];

/* Paket D 23 pemeriksaan; E menambah tujuh; F menambah tiga lagi.
   Ditulis bertingkat supaya urutannya tidak pernah menyimpang. */
const ISI_D = [
  P.hematologi,
  P.urine,
  P.ureum,
  P.kreatinin,
  P.asamUrat,
  P.proteinTotal,
  P.albumin,
  P.globulin,
  P.bilirubinTotal,
  P.bilirubinIndirek,
  P.bilirubinDirek,
  P.sgot,
  P.sgpt,
  P.glukosa,
  P.hba1c,
  P.kolesterolTotal,
  P.kolesterolHdl,
  P.kolesterolLdl,
  P.trigliserida,
  P.hbsag,
  P.antiHbs,
  P.ekg,
  P.konsulPenyakitDalam,
];

const ISI_E = [
  ...ISI_D,
  P.elektrolit,
  P.antiHcv,
  P.vdrl,
  P.gammaGt,
  P.fosfataseAlkali,
  P.ldh,
  P.lipoproteinA,
];

/* Poster menulis Paket F sebagai rumus: "Paket E + Ca Mg + VIT D".
   Ketiganya dijabarkan supaya daftarnya bisa dibaca utuh. */
const ISI_F = [
  ...ISI_E,
  { id: "Kalsium (Ca)", en: "Calcium (Ca)" },
  { id: "Magnesium (Mg)", en: "Magnesium (Mg)" },
  { id: "Vitamin D", en: "Vitamin D" },
];

const PAKET_GENERAL = [
  {
    kode: "A",
    nama: { id: "Paket A", en: "Package A" },
    julukan: { id: "Basic", en: "Basic" },
    harga: 335000,
    isi: [
      P.hematologi,
      P.urine,
      { id: "Gula darah sewaktu", en: "Random blood glucose" },
      P.kolesterolTotal,
      { id: "Konsultasi dokter umum", en: "General practitioner consultation" },
    ],
    varian: {
      dasar: 335000,
      golDarah: 405000,
      faeces: 430000,
      thorax: 525000,
      usg: null,
      papSmear: null,
      psa: null,
      gigi: null,
      mata: null,
      semua: 690000,
    },
  },

  {
    kode: "B",
    nama: { id: "Paket B", en: "Package B" },
    julukan: { id: "Silver", en: "Silver" },
    catatan: {
      id: "Paket ekonomis untuk semua usia, wanita dan pria.",
      en: "Economy package for all ages, women and men.",
    },
    harga: 1080000,
    isi: [
      P.hematologi,
      P.urine,
      P.ureum,
      P.kreatinin,
      P.asamUrat,
      P.sgot,
      P.sgpt,
      P.trigliserida,
      P.glukosa,
      P.kolesterolTotal,
      P.ekg,
      P.konsulPenyakitDalam,
    ],
    varian: {
      dasar: 1080000,
      golDarah: 1150000,
      faeces: 1175000,
      /* ⚠️ Selisihnya Rp 290.000, sementara semua paket lain Rp 190.000
         untuk foto thorax. Kemungkinan salah ketik di poster; angkanya
         DIBIARKAN sesuai poster sampai keuangan mengonfirmasi. */
      thorax: 1370000,
      usg: 1430000,
      papSmear: 1490000,
      psa: 1530000,
      gigi: 1255000,
      mata: 1255000,
      semua: null,
    },
  },

  {
    kode: "C",
    nama: { id: "Paket C", en: "Package C" },
    julukan: { id: "Eksklusif / Gold", en: "Exclusive / Gold" },
    harga: 1730000,
    isi: [
      P.hematologi,
      P.urine,
      P.ureum,
      P.kreatinin,
      P.asamUrat,
      P.sgot,
      P.sgpt,
      P.glukosa,
      P.hba1c,
      P.kolesterolTotal,
      P.kolesterolHdl,
      P.kolesterolLdl,
      P.trigliserida,
      P.hbsag,
      P.antiHbs,
      P.ekg,
      P.konsulPenyakitDalam,
    ],
    varian: {
      dasar: 1730000,
      golDarah: 1800000,
      faeces: 1825000,
      thorax: 1920000,
      usg: 2080000,
      papSmear: 2140000,
      psa: 2180000,
      gigi: 1905000,
      mata: 1905000,
      semua: null,
    },
  },

  {
    kode: "D",
    nama: { id: "Paket D", en: "Package D" },
    julukan: { id: "Diamond", en: "Diamond" },
    harga: 2460000,
    isi: ISI_D,
    varian: {
      dasar: 2460000,
      golDarah: 2530000,
      faeces: 2555000,
      thorax: 2650000,
      usg: 2810000,
      papSmear: 2870000,
      psa: 2910000,
      gigi: 2635000,
      mata: 2635000,
      semua: null,
    },
  },

  {
    kode: "E",
    nama: { id: "Paket E", en: "Package E" },
    julukan: { id: "Platinum", en: "Platinum" },
    harga: 4000000,
    isi: ISI_E,
    varian: {
      dasar: 4000000,
      golDarah: 4070000,
      faeces: 4095000,
      thorax: 4190000,
      usg: 4350000,
      papSmear: 4410000,
      psa: 4450000,
      gigi: 4175000,
      /* Poster menulis "Paket ET + Periksa Mata" - salah ketik pada
         posternya; angkanya sama dengan baris periksa gigi. */
      mata: 4175000,
      semua: null,
    },
  },

  {
    kode: "F",
    nama: { id: "Paket F", en: "Package F" },
    julukan: { id: "Singapura", en: "Singapore" },
    catatan: {
      id: "Paket E ditambah kalsium, magnesium, dan vitamin D.",
      en: "Package E plus calcium, magnesium and vitamin D.",
    },
    harga: 4950000,
    isi: ISI_F,
    varian: {
      dasar: 4950000,
      golDarah: null,
      faeces: null,
      thorax: null,
      usg: null,
      papSmear: null,
      psa: null,
      gigi: null,
      mata: null,
      semua: null,
    },
  },
];

/* ============================================================
   MCU SESUAI USIA

   Keempat paket TIDAK PUNYA HARGA di poster mana pun. `harga: null`
   bukan lupa diisi - angkanya memang tidak dicetak.

   Tidak ada pilihan tambahan untuk kategori ini, jadi `varian`
   hanya berisi `dasar`, dan tabel tambahan tidak dirender.
   ============================================================ */
const PAKET_USIA = [
  {
    kode: "18-25",
    nama: { id: "Usia 18 - 25 tahun", en: "Ages 18 - 25" },
    julukan: null,
    harga: null,
    isi: [
      P.hematologiDpl,
      P.urine,
      P.kreatinin,
      P.asamUrat,
      P.sgpt,
      P.glukosa,
      P.kolesterolTotal,
      P.trigliserida,
      P.konsulPenyakitDalam,
    ],
    varian: { dasar: null },
  },

  {
    kode: ">25-40",
    nama: { id: "Usia di atas 25 - 40 tahun", en: "Ages over 25 - 40" },
    julukan: null,
    harga: null,
    isi: [
      P.hematologiDpl,
      P.urine,
      P.kreatinin,
      P.asamUrat,
      P.sgpt,
      P.glukosa,
      P.kolesterolTotal,
      P.kolesterolHdlLdl,
      P.trigliserida,
      P.hba1c,
      P.hbsagPolos,
      P.antiHbsPolos,
      P.fotoThorax,
      P.konsulPenyakitDalam,
    ],
    varian: { dasar: null },
  },

  {
    kode: ">40-50",
    nama: { id: "Usia di atas 40 - 50 tahun", en: "Ages over 40 - 50" },
    julukan: null,
    harga: null,
    isi: [
      P.hematologiDpl,
      P.urine,
      P.ureum,
      P.kreatinin,
      P.asamUrat,
      P.sgot,
      P.sgpt,
      P.glukosa,
      P.kolesterolTotal,
      P.kolesterolHdlLdl,
      P.trigliserida,
      P.hba1c,
      P.hbsag,
      P.antiHbs,
      P.antiHcvTiter,
      P.fotoThorax,
      P.usgAbdomen,
      P.ekg,
      P.konsulPenyakitDalam,
    ],
    varian: { dasar: null },
  },

  {
    kode: ">50",
    nama: { id: "Usia di atas 50 tahun", en: "Ages over 50" },
    julukan: null,
    harga: null,
    isi: [
      P.hematologiDpl,
      P.urine,
      P.ureum,
      P.kreatinin,
      P.asamUrat,
      P.proteinTotal,
      P.albumin,
      P.globulin,
      P.sgot,
      P.sgpt,
      P.glukosa,
      P.kolesterolTotal,
      P.kolesterolHdlLdl,
      P.trigliserida,
      P.bilirubinTotal,
      P.bilirubinDirek,
      P.bilirubinIndirek,
      P.hba1c,
      P.hbsag,
      P.antiHbs,
      P.antiHcvTiter,
      P.gammaGt,
      P.cholineEsterase,
      P.fotoThorax,
      P.usgAbdomen,
      P.ekg,
      P.konsulPenyakitDalam,
    ],
    varian: { dasar: null },
  },
];

/* ============================================================
   MCU ANAK

   Dari poster 7.jpeg. Harga ditulis "560 ribu" dan seterusnya -
   di sini disimpan sebagai angka penuh.

   ⚠️ PENOMORAN DI POSTER PAKET REMAJA SALAH: nomor 4 dipakai dua
   kali (HBSAG dan Anti HCV), sehingga daftarnya berhenti di nomor 7
   padahal isinya delapan pemeriksaan. Kedelapannya ditulis di sini,
   dan halaman menomori ulang dengan benar. Beri tahu marketing
   supaya posternya ikut diperbaiki.
   ============================================================ */
const PAKET_ANAK = [
  {
    kode: "0-1",
    nama: { id: "MCU Bayi", en: "Infant Check Up" },
    julukan: { id: "0 - 1 tahun", en: "0 - 1 year" },
    harga: 560000,
    isi: [P.tshNeonatus, P.hematologi, P.golonganDarahRhesus],
    varian: { dasar: 560000 },
  },

  {
    kode: "1-5",
    nama: { id: "MCU Balita", en: "Toddler Check Up" },
    julukan: { id: "1 - 5 tahun", en: "1 - 5 years" },
    harga: 755000,
    isi: [P.darahLengkap, P.totalProtein, P.profilLipid, P.feritin],
    varian: { dasar: 755000 },
  },

  {
    kode: "5-10",
    nama: { id: "MCU Usia Sekolah Dini", en: "Early School Age Check Up" },
    julukan: { id: "5 - 10 tahun", en: "5 - 10 years" },
    harga: 850000,
    isi: [P.darahLengkap, P.totalProtein, P.profilLipid, P.feritin, P.faecesLengkap],
    varian: { dasar: 850000 },
  },

  {
    kode: "10-18",
    nama: { id: "MCU Remaja", en: "Teen Check Up" },
    julukan: { id: "10 - 18 tahun", en: "10 - 18 years" },
    harga: 865000,
    isi: [
      P.darahLengkap,
      P.totalProtein,
      P.profilLipid,
      P.hbsagPolos,
      P.antiHcv,
      P.faecesLengkap,
      P.fungsiGinjal,
      P.fungsiHati,
    ],
    varian: { dasar: 865000 },
  },

  /* ============================================================
     SCREENING GINJAL ANAK - dari poster 9.jpeg

     ⚠️⚠️ LENCANA "DISKON 20%" AKTIF TANPA TANGGAL BERAKHIR.

     Dinyalakan atas permintaan pemilik situs. Karena `berlakuSampai`
     kosong, lencananya TIDAK AKAN PERNAH HILANG SENDIRI - ia terus
     tampil sampai ada orang yang membuka berkas ini dan mencabutnya.

     Sumbernya poster bernama "WhatsApp Image 2023-02-24". Kalau
     promonya sudah berakhir, halaman ini menjanjikan potongan harga
     yang tidak bisa ditepati, dan yang menghadapi pasien di kasir
     bukan yang memasangnya.

     BEGITU TANGGAL BERAKHIRNYA DIKETAHUI, isi `berlakuSampai`:

         promo: {
           label: { id: "Diskon 20%", en: "20% off" },
           berlakuSampai: "2026-12-31",
         },

     Dengan tanggal terisi, lencananya berhenti sendiri lewat hari
     itu - tanpa perlu ada yang ingat mencabutnya.

     CARA MEMATIKANNYA SEKARANG: ganti seluruh blok `promo` jadi
     `promo: null`.

     Harga tidak tercantum di poster, jadi `harga: null` dan kartunya
     menampilkan "Hubungi kami".
     ============================================================ */
  {
    kode: "Ginjal",
    nama: { id: "Screening Ginjal Anak", en: "Children's Kidney Screening" },
    julukan: null,
    catatan: {
      id: "Paket pemeriksaan terfokus, di luar rangkaian MCU sesuai tahap usia.",
      en: "A focused screening package, separate from the age-stage check up series.",
    },
    harga: null,
    promo: {
      label: { id: "Diskon 20%", en: "20% off" },
      /* Kosong = tidak berbatas waktu. Isi begitu tanggalnya pasti. */
      berlakuSampai: null,
    },
    isi: [P.konsulSpesialisAnak, P.labDarahLengkap, P.labFungsiGinjal],
    varian: { dasar: null },
  },
];

/* ============================================================
   MCU BABY SITTER / DRIVER / CARE GIVER

   Kategori ini punya pilihan tambahan SENDIRI, berbeda dari MCU
   General - ada fungsi ginjal, fungsi hati, dan Anti HCV, tapi
   tidak ada USG, Pap smear, PSA, maupun periksa gigi. Karena itu
   daftar variannya ditulis terpisah, bukan meminjam punya General.

   Perhatikan EKG: posternya menulis "( > 30 tahun )" - syarat usia,
   bukan bagian dari nama pemeriksaan. Ditulis ikut di labelnya
   supaya syarat itu tidak hilang saat dipindahkan ke tabel.
   ============================================================ */
const VARIAN_PENDAMPING = [
  { kunci: "dasar", nama: { id: "Paket dasar", en: "Base package" } },
  { kunci: "golDarah", nama: { id: "+ Golongan darah", en: "+ Blood type" } },
  { kunci: "faeces", nama: { id: "+ Faeces lengkap", en: "+ Full stool test" } },
  { kunci: "thorax", nama: { id: "+ Foto thorax", en: "+ Chest X-ray" } },
  { kunci: "antiHcv", nama: { id: "+ Anti HCV", en: "+ Anti-HCV" } },
  { kunci: "fungsiGinjal", nama: { id: "+ Fungsi ginjal", en: "+ Kidney function" } },
  { kunci: "fungsiHati", nama: { id: "+ Fungsi hati", en: "+ Liver function" } },
  {
    kunci: "ekg",
    nama: { id: "+ EKG (di atas 30 tahun)", en: "+ ECG (over 30 years old)" },
  },
  { kunci: "mata", nama: { id: "+ Periksa mata", en: "+ Eye check" } },
];

const PAKET_PENDAMPING = [
  {
    kode: "A",
    nama: { id: "Paket A", en: "Package A" },
    julukan: null,
    harga: 340000,
    isi: [P.hematologiLed, P.urine, P.gulaDarahSewaktu, P.konsulUmum],
    varian: {
      dasar: 340000,
      golDarah: 410000,
      faeces: 430000,
      thorax: 530000,
      antiHcv: null,
      fungsiGinjal: null,
      fungsiHati: null,
      ekg: null,
      mata: null,
    },
  },

  {
    kode: "B",
    nama: { id: "Paket B", en: "Package B" },
    julukan: null,
    harga: 460000,
    isi: [
      P.hematologiLed,
      P.urine,
      P.gulaDarahSewaktu,
      P.hbsagPolos,
      P.antiHbsPolos,
      P.konsulUmum,
    ],
    varian: {
      dasar: 460000,
      golDarah: 530000,
      faeces: 550000,
      thorax: 650000,
      antiHcv: 560000,
      fungsiGinjal: 605000,
      fungsiHati: 600000,
      ekg: 530000,
      mata: 635000,
    },
  },

  {
    kode: "C",
    nama: { id: "Paket C", en: "Package C" },
    julukan: null,
    harga: 680000,
    isi: [
      P.hematologiLed,
      P.urine,
      P.ureum,
      P.kreatinin,
      P.gulaDarahSewaktu,
      P.antiHbsPolos,
      P.antiHcv,
      P.hbsagPolos,
      P.konsulUmum,
    ],
    /* Anti HCV tidak jadi tambahan di sini karena sudah termasuk
       dalam paketnya - dan posternya memang tidak mencantumkannya. */
    varian: {
      dasar: 680000,
      golDarah: 750000,
      faeces: 770000,
      /* ⚠️ Selisihnya Rp 210.000 sementara Paket A dan B Rp 190.000. */
      thorax: 890000,
      antiHcv: null,
      fungsiGinjal: 825000,
      fungsiHati: 820000,
      ekg: 750000,
      /* ⚠️ Selisihnya Rp 145.000 sementara Paket B Rp 175.000 - dan
         kebetulan sama persis dengan baris fungsi ginjal di atasnya,
         yang mengesankan salah salin saat poster dibuat. */
      mata: 825000,
    },
  },
];

/* ============================================================
   MCU EKONOMIS - satu paket, 312 ribu

   Posternya menulis isinya sebagai satu baris:
   "(DOKTER + LAB DARAH + URINE + RONTGEN)". Dipecah jadi empat
   butir di sini supaya bisa dibaca sebagai daftar - bukan tambahan
   dari saya, hanya penjabaran tanda plus di posternya.

   Golongan darah ditulis posternya sebagai SELISIH ("tambah 20
   ribu"), bukan harga total seperti poster-poster lain. 312 + 20 =
   332 ribu; penjumlahan ini aman karena angkanya disebut eksplisit
   dan cuma ada satu tambahan - beda dengan MCU General, yang
   tambahannya tidak pernah disebut selisihnya.
   ============================================================ */
const VARIAN_EKONOMIS = [
  { kunci: "dasar", nama: { id: "Paket dasar", en: "Base package" } },
  {
    kunci: "golDarah",
    nama: {
      id: "+ Golongan darah (bagi yang belum tahu golongannya)",
      en: "+ Blood type (for those who do not know theirs)",
    },
  },
];

const PAKET_EKONOMIS = [
  {
    kode: "Ekonomis",
    nama: { id: "MCU Ekonomis", en: "Economy Check Up" },
    julukan: null,
    harga: 312000,
    isi: [P.pemeriksaanDokter, P.labDarah, P.urine, P.rontgen],
    varian: {
      dasar: 312000,
      golDarah: 332000,
    },
  },
];

/* ============================================================
   MCU PREMARITAL

   ⚠️ POSTERNYA HANYA MEMUAT HARGA - tidak ada satu pun nama
   pemeriksaan. Karena itu `isi` kosong untuk kelima paket, dan
   halaman tidak merender bagian "Rincian Pemeriksaan" sama sekali
   untuk kategori ini. Pasien yang ingin tahu isinya harus bertanya
   ke customer service.

   Ini kekurangan yang serius untuk paket seharga sampai Rp 3,7 juta.
   Minta daftar pemeriksaannya ke marketing.

   ============================================================
   HARGA BERBEDA ANTARA PRIA DAN WANITA

   Poster memakai lambang ♂ dan ♀ di sebelah tiap harga:

     Standard  Rp   690.000   ♂ ♀   (sama untuk keduanya)
     Silver    Rp   789.000   ♂
               Rp 2.530.000   ♀
     Gold      Rp 2.300.000   ♂
               Rp 3.700.000   ♀

   Ditulis sebagai lima paket terpisah, bukan tiga paket dengan dua
   harga. Alasannya: orang yang membuka halaman ini sudah tahu dirinya
   pria atau wanita, dan yang dia cari satu angka - bukan tabel yang
   harus dibaca dua kali.

   Selisih Silver pria dan wanita lebih dari tiga kali lipat. Wajar
   kalau pemeriksaannya memang berbeda jauh, tapi tanpa daftar isinya
   pengunjung tidak punya cara menilai. Satu alasan lagi daftar
   pemeriksaannya perlu segera dilengkapi.

   ============================================================
   Poster menulis "Mulai dari" di atas daftar harganya - jadi angka
   ini harga terendah, bukan harga pasti. Ditegaskan di catatan
   kategori supaya tidak dibaca sebagai harga akhir.
   ============================================================ */
const PAKET_PREMARITAL = [
  {
    kode: "Standard",
    nama: { id: "Paket Standard", en: "Standard Package" },
    julukan: { id: "Pria & wanita", en: "Men & women" },
    harga: 690000,
    isi: [],
    varian: { dasar: 690000 },
  },
  {
    kode: "Silver Pria",
    nama: { id: "Paket Silver", en: "Silver Package" },
    julukan: { id: "Pria", en: "Men" },
    harga: 789000,
    isi: [],
    varian: { dasar: 789000 },
  },
  {
    kode: "Silver Wanita",
    nama: { id: "Paket Silver", en: "Silver Package" },
    julukan: { id: "Wanita", en: "Women" },
    harga: 2530000,
    isi: [],
    varian: { dasar: 2530000 },
  },
  {
    kode: "Gold Pria",
    nama: { id: "Paket Gold", en: "Gold Package" },
    julukan: { id: "Pria", en: "Men" },
    harga: 2300000,
    isi: [],
    varian: { dasar: 2300000 },
  },
  {
    kode: "Gold Wanita",
    nama: { id: "Paket Gold", en: "Gold Package" },
    julukan: { id: "Wanita", en: "Women" },
    harga: 3700000,
    isi: [],
    varian: { dasar: 3700000 },
  },
];

/* ============================================================
   TES URIN NARKOBA

   ⚠️ ASAL-USUL KEDUA ANGKA DI BAWAH - BACA SEBELUM MENGUBAH

     Rp 135.000  Poster aslinya memuat keterangan tercetak
                 "*Berlaku s.d 31 Oktober 2022" dan pita "LIMITED
                 OFFER". Keterangan tanggal itu DIHAPUS dari gambar
                 atas permintaan pemilik situs, dan angkanya
                 ditayangkan sebagai tarif berlaku.

     Rp 360.000  Paket bersama konsultasi dokter spesialis. Posternya
                 bertanda "SPECIAL OFFER", dibuat dalam rangka Hari
                 HIV AIDS Sedunia (1 Desember) - jadi kemungkinan
                 besar juga penawaran musiman, hanya saja tanggal
                 berakhirnya tidak pernah dicetak.

   Keduanya berasal dari materi tahun 2022. Kalau ternyata tarifnya
   sudah berubah, kembalikan `harga` jadi null - kartunya otomatis
   menampilkan "Hubungi kami".

   Kalau penawarannya memang dijalankan berbatas waktu, pakai medan
   `promo` beserta `berlakuSampai` supaya lencananya berhenti sendiri
   - lihat contohnya di paket Screening Ginjal Anak.

   ============================================================
   POSTER TIDAK MENYEBUT KEENAM PARAMETERNYA

   "6 Parameter" muncul di judul, tapi zat apa saja yang diperiksa
   tidak tertulis di mana pun. Untuk tes yang dipakai orang sebagai
   syarat kerja atau sekolah, daftar itu justru yang menentukan
   diterima atau tidaknya hasil. `isi` dikosongkan; minta daftarnya
   ke laboratorium.
   ============================================================ */
const PAKET_NARKOBA = [
  {
    kode: "6 Parameter",
    nama: { id: "Tes Urin Narkoba 6 Parameter", en: "6-Parameter Drug Urine Test" },
    julukan: null,
    harga: 135000,
    isi: [],
    varian: { dasar: null },
  },
];

export const KATEGORI = [
  {
    kunci: "general",
    nama: { id: "MCU General", en: "General Check Up" },
    ringkas: {
      id: "Enam paket, dari yang paling ringkas sampai yang paling lengkap, dengan pilihan pemeriksaan tambahan.",
      en: "Six packages, from the most basic to the most complete, with optional add-on examinations.",
    },
    paket: PAKET_GENERAL,
    varian: VARIAN_GENERAL,
    poster: [
      {
        gambar: poster1,
        judul: { id: "Lembar 1 - Paket A sampai D", en: "Sheet 1 - Packages A to D" },
        alt: {
          id: "Poster MCU General lembar pertama: rincian pemeriksaan dan harga Paket A, B, C, dan D beserta pilihan tambahannya.",
          en: "General check up poster, first sheet: examinations and prices for packages A, B, C and D with add-on options.",
        },
      },
      {
        gambar: poster2,
        judul: { id: "Lembar 2 - Paket E dan F", en: "Sheet 2 - Packages E and F" },
        alt: {
          id: "Poster MCU General lembar kedua: tambahan Paket D, rincian Paket E dan F, serta daftar pemeriksaan gratis.",
          en: "General check up poster, second sheet: package D add-ons, packages E and F, and the complimentary items.",
        },
      },
    ],
    gratis: [
      {
        nama: { id: "Ukur tensi", en: "Blood pressure check" },
        untuk: { id: "Semua paket", en: "All packages" },
      },
      {
        nama: { id: "Ukur tinggi dan berat badan", en: "Height and weight measurement" },
        untuk: { id: "Semua paket", en: "All packages" },
      },
      {
        nama: { id: "BMI (Indeks Massa Tubuh)", en: "BMI (Body Mass Index)" },
        untuk: { id: "Semua paket", en: "All packages" },
      },
      {
        nama: { id: "eGFR / fungsi ginjal (CKD-EPI)", en: "eGFR / kidney function (CKD-EPI)" },
        untuk: { id: "Paket B ke atas", en: "Package B and above" },
      },
      {
        nama: { id: "Makan 1x", en: "One complimentary meal" },
        untuk: { id: "Paket B ke atas", en: "Package B and above" },
      },
    ],
    catatan: [
      {
        id: "Paket MCU General ditujukan untuk usia 18 sampai 80 tahun.",
        en: "The general check up packages are intended for ages 18 to 80.",
      },
    ],
  },

  {
    kunci: "usia",
    nama: { id: "MCU Sesuai Usia", en: "Check Up by Age" },
    ringkas: {
      id: "Paket ekonomis yang disusun mengikuti kelompok usia. Rincian tarif melalui customer service.",
      en: "Economy packages arranged by age group. Pricing is available from customer service.",
    },
    paket: PAKET_USIA,
    /* Kosong = tabel tambahan tidak dirender untuk kategori ini. */
    varian: [],
    poster: [
      {
        gambar: poster3,
        judul: { id: "Sampul", en: "Cover" },
        alt: {
          id: "Sampul brosur Paket Medical Check Up Ekonomis Sesuai Usia RS JMC.",
          en: "Cover of the RS JMC economy check up by age brochure.",
        },
      },
      {
        gambar: poster4,
        judul: { id: "Usia 18 - 40 tahun", en: "Ages 18 - 40" },
        alt: {
          id: "Daftar pemeriksaan paket usia 18-25 tahun dan di atas 25-40 tahun.",
          en: "Examination list for the ages 18-25 and over 25-40 packages.",
        },
      },
      {
        gambar: poster5,
        judul: { id: "Usia di atas 40 - 50 tahun", en: "Ages over 40 - 50" },
        alt: {
          id: "Daftar pemeriksaan paket usia di atas 40 sampai 50 tahun.",
          en: "Examination list for the ages over 40 to 50 package.",
        },
      },
      {
        gambar: poster6,
        judul: { id: "Usia di atas 50 tahun", en: "Ages over 50" },
        alt: {
          id: "Daftar pemeriksaan paket usia di atas 50 tahun beserta daftar pemeriksaan gratis.",
          en: "Examination list for the ages over 50 package with the complimentary items.",
        },
      },
    ],
    /* ⚠️ Daftar gratis ini HANYA tercetak di lembar usia >50 tahun.
       Apakah berlaku untuk keempat kelompok usia atau khusus >50,
       tidak jelas dari posternya. Cakupannya sengaja ditulis
       "Perlu dikonfirmasi" - bukan diklaim berlaku untuk semua.
       Ganti begitu marketing menjawab. */
    gratis: [
      {
        nama: { id: "Ukur tensi", en: "Blood pressure check" },
        untuk: { id: "Perlu dikonfirmasi", en: "To be confirmed" },
      },
      {
        nama: { id: "Ukur tinggi dan berat badan", en: "Height and weight measurement" },
        untuk: { id: "Perlu dikonfirmasi", en: "To be confirmed" },
      },
      {
        nama: { id: "IMT (Indeks Massa Tubuh)", en: "BMI (Body Mass Index)" },
        untuk: { id: "Perlu dikonfirmasi", en: "To be confirmed" },
      },
      {
        nama: { id: "eGFR (CKD-EPI)", en: "eGFR (CKD-EPI)" },
        untuk: { id: "Perlu dikonfirmasi", en: "To be confirmed" },
      },
    ],
    catatan: [],
  },

  {
    kunci: "anak",
    nama: { id: "MCU Anak", en: "Children's Check Up" },
    ringkas: {
      id: "Paket pemeriksaan untuk bayi sampai remaja, disusun mengikuti tahap usia.",
      en: "Screening packages for infants through teenagers, arranged by age stage.",
    },
    paket: PAKET_ANAK,
    /* Tidak ada pilihan tambahan di poster, jadi tabel tidak dirender. */
    varian: [],
    poster: [
      {
        gambar: poster7,
        judul: { id: "Paket MCU Anak", en: "Children's Check Up Packages" },
        alt: {
          id: "Poster MCU Anak: rincian pemeriksaan dan harga paket bayi, balita, usia sekolah dini, dan remaja.",
          en: "Children's check up poster: examinations and prices for the infant, toddler, early school age and teen packages.",
        },
      },
      {
        gambar: poster8,
        /* ⚠️ BELUM SAYA LIHAT ISINYA. Judul dan alt ini tebakan
           berdasarkan posisinya sebagai lembar kedua. Kalau isinya
           ternyata paket yang belum ada di atas, datanya masih
           kurang - kirimkan gambarnya. */
        judul: { id: "Lembar 2", en: "Sheet 2" },
        alt: {
          id: "Poster paket MCU Anak RS JMC, lembar kedua.",
          en: "RS JMC children's check up poster, second sheet.",
        },
      },
      {
        gambar: poster9,
        judul: { id: "Screening Ginjal Anak", en: "Children's Kidney Screening" },
        alt: {
          id: "Poster Paket Screening Ginjal Anak RS JMC: pemeriksaan dokter spesialis anak, darah lengkap, dan fungsi ginjal.",
          en: "RS JMC children's kidney screening poster: paediatrician examination, complete blood count and kidney function tests.",
        },
      },
    ],
    /* Kotak "GRATIS" tercetak DI DALAM bingkai yang sama dengan
       keempat paket anak, bukan di lembar terpisah - karena itu
       cakupannya dibaca berlaku untuk semuanya. Beda dengan daftar
       gratis di MCU Sesuai Usia, yang hanya tercetak di lembar >50
       sehingga cakupannya tidak bisa dipastikan. */
    gratis: [
      {
        nama: { id: "Ukur tinggi dan berat badan", en: "Height and weight measurement" },
        untuk: { id: "Semua paket anak", en: "All children's packages" },
      },
      {
        nama: { id: "IMT (Indeks Massa Tubuh)", en: "BMI (Body Mass Index)" },
        untuk: { id: "Semua paket anak", en: "All children's packages" },
      },
      {
        nama: { id: "Buku check up", en: "Check up booklet" },
        untuk: { id: "Semua paket anak", en: "All children's packages" },
      },
    ],
    /* Dari poster Screening Ginjal. Ditulis di sini, bukan cuma
       dibiarkan di dalam gambar, karena ini satu-satunya kalimat di
       seluruh berkas ini yang menyangkut keadaan mendesak - dan itu
       justru yang paling tidak boleh hanya ada di dalam JPG. */
    catatan: [
      {
        id: "Jika anak menunjukkan gejala kegawatdaruratan, langsung ke IGD RS JMC yang buka 24 jam.",
        en: "If your child shows emergency symptoms, go straight to the RS JMC emergency department, open 24 hours.",
      },
    ],
  },

  {
    kunci: "baby-sitter-driver",
    nama: { id: "MCU Baby Sitter / Driver / Care Giver", en: "Check Up for Baby Sitters / Drivers / Care Givers" },
    /* Nama panjangnya tidak muat di tombol lompat di kepala halaman. */
    namaSingkat: { id: "Baby Sitter / Driver", en: "Baby Sitter / Driver" },
    ringkas: {
      id: "Tiga paket pemeriksaan untuk pekerja rumah tangga, pengemudi, dan pendamping lansia, dengan pilihan pemeriksaan tambahan.",
      en: "Three screening packages for domestic staff, drivers and care givers, with optional add-on examinations.",
    },
    paket: PAKET_PENDAMPING,
    varian: VARIAN_PENDAMPING,
    poster: [
      {
        gambar: poster10,
        judul: { id: "Paket A, B, dan C", en: "Packages A, B and C" },
        alt: {
          id: "Poster MCU Baby Sitter, Driver, dan Care Giver RS JMC: rincian pemeriksaan dan harga Paket A, B, dan C beserta pilihan tambahannya.",
          en: "RS JMC check up poster for baby sitters, drivers and care givers: examinations and prices for packages A, B and C with add-on options.",
        },
      },
      {
        gambar: poster11,
        /* ⚠️ BELUM SAYA LIHAT ISINYA. Judul dan alt ini tebakan
           berdasarkan posisinya sebagai lembar kedua. */
        judul: { id: "Lembar 2", en: "Sheet 2" },
        alt: {
          id: "Poster MCU Baby Sitter, Driver, dan Care Giver RS JMC, lembar kedua.",
          en: "RS JMC check up poster for baby sitters, drivers and care givers, second sheet.",
        },
      },
    ],
    /* Poster tidak mencantumkan daftar gratis untuk kategori ini. */
    gratis: [],
    catatan: [],
  },

  {
    kunci: "ekonomis",
    nama: { id: "MCU Ekonomis", en: "Economy Check Up" },
    ringkas: {
      id: "Satu paket ringkas berisi pemeriksaan dokter, laboratorium darah, urine, dan rontgen.",
      en: "A single compact package covering a doctor's examination, blood tests, urinalysis and an X-ray.",
    },
    paket: PAKET_EKONOMIS,
    varian: VARIAN_EKONOMIS,
    poster: [
      {
        gambar: poster12,
        judul: { id: "MCU Ekonomis", en: "Economy Check Up" },
        alt: {
          id: "Poster MCU Ekonomis RS JMC seharga 312 ribu, berisi pemeriksaan dokter, laboratorium darah, urine, dan rontgen.",
          en: "RS JMC economy check up poster priced at 312 thousand rupiah, covering a doctor's examination, blood tests, urinalysis and an X-ray.",
        },
      },
      {
        gambar: poster13,
        /* ⚠️ BELUM SAYA LIHAT ISINYA. */
        judul: { id: "Lembar 2", en: "Sheet 2" },
        alt: {
          id: "Poster MCU Ekonomis RS JMC, lembar kedua.",
          en: "RS JMC economy check up poster, second sheet.",
        },
      },
    ],
    /* Poster menulis "*EKSTRA URINE DAN GULA DARAH GRATIS". Kalimatnya
       ambigu - "ekstra urine" bisa berarti pemeriksaan urine tambahan,
       bisa juga sekadar penegasan bahwa urine sudah termasuk.
       Ditulis mendekati aslinya sampai RS menjelaskan. */
    gratis: [
      {
        nama: { id: "Ekstra urine", en: "Extra urinalysis" },
        untuk: { id: "Termasuk paket", en: "Included" },
      },
      {
        nama: { id: "Gula darah", en: "Blood glucose" },
        untuk: { id: "Termasuk paket", en: "Included" },
      },
    ],
    catatan: [
      {
        id: "Pemeriksaan golongan darah dapat ditambahkan dengan biaya Rp 20.000, bagi yang belum mengetahui golongan darahnya.",
        en: "A blood type test can be added for Rp 20,000, for those who do not yet know their blood type.",
      },
      {
        id: "Informasi dan pendaftaran: (021) 798 5177 atau 0811 901 874.",
        en: "Information and registration: (021) 798 5177 or 0811 901 874.",
      },
    ],
  },

  {
    kunci: "premarital",
    nama: { id: "MCU Premarital", en: "Premarital Check Up" },
    ringkas: {
      id: "Pemeriksaan sebelum menikah, tersedia dalam tiga tingkatan dengan harga berbeda untuk pria dan wanita.",
      en: "Pre-wedding screening, available in three tiers with separate pricing for men and women.",
    },
    paket: PAKET_PREMARITAL,
    /* Tidak ada pilihan tambahan di poster. */
    varian: [],
    poster: [
      {
        gambar: poster14,
        judul: { id: "MCU Premarital", en: "Premarital Check Up" },
        alt: {
          id: "Poster MCU Premarital RS JMC berisi daftar harga paket Standard, Silver, dan Gold untuk pria dan wanita.",
          en: "RS JMC premarital check up poster listing the Standard, Silver and Gold package prices for men and women.",
        },
      },
    ],
    gratis: [],
    catatan: [
      {
        id: "Harga di atas adalah harga mulai dari, sesuai keterangan pada poster. Mohon konfirmasi ke customer service.",
        en: "The prices above are starting prices, as stated on the poster. Please confirm with customer service.",
      },
      {
        id: "Rincian pemeriksaan tiap paket dapat ditanyakan ke customer service.",
        en: "The examination list for each package is available from customer service.",
      },
    ],
  },

  {
    kunci: "narkoba",
    nama: { id: "Tes Urin Narkoba", en: "Drug Urine Test" },
    ringkas: {
      id: "Pemeriksaan Tes Urin enam Parameter.",
      en: "Six Parameter Urine Test Examination",
    },
    paket: PAKET_NARKOBA,
    varian: [],
    poster: [
      {
        gambar: poster15,
        judul: { id: "Tes Urin Narkoba 6 Parameter", en: "6-Parameter Drug Urine Test" },
        alt: {
          id: "Poster tes urin narkoba enam parameter RS JMC, dengan keterangan penawaran terbatas.",
          en: "RS JMC six-parameter drug urine test poster, marked as a limited offer.",
        },
      },
    ],
    gratis: [],
  },
];

/* ============================================================
   CATATAN YANG BERLAKU UNTUK SEMUA KATEGORI
   Dari poster MCU General lembar kedua.
   ============================================================ */
export const CATATAN_UMUM = [
  {
    id: "Reservasi dilakukan maksimal H-1 sebelum pemeriksaan.",
    en: "Reservations must be made at least one day before the examination.",
  },
  {
    id: "Hasil pemeriksaan dapat dikirimkan melalui JMC Send, gratis untuk jarak di bawah 5 km.",
    en: "Results can be delivered via JMC Send, free of charge within 5 km.",
  },
];

/* ============================================================
   PERSIAPAN SEBELUM MCU

   MASIH KOSONG, SENGAJA - dan sekarang lebih mendesak daripada
   sebelumnya. SEPULUH dari sebelas paket di halaman ini memuat
   "Glukosa puasa", termasuk keempat paket sesuai usia. Aturan
   puasanya pasti ada, tapi tidak tertulis di satu pun dari enam
   lembar poster.

   Pasien yang datang tanpa tahu harus pulang dan mengulang.

   Minta lembar persiapan MCU ke laboratorium atau marketing, lalu
   tempel di sini - bagiannya muncul sendiri di halaman.
     { id: "...", en: "..." },
   ============================================================ */
export const PERSIAPAN = [];
